import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  downloadLinkDocuments,
  downloadOrderDocuments,
  fetchSalesOrderAttachments,
} from '@/api/orders';

export const salesOrderAttachmentKeys = {
  detail: (soId: string) => ['salesOrderAttachments', soId] as const,
};

export function useSalesOrderAttachments(soId: string | null | undefined) {
  return useQuery({
    queryKey: salesOrderAttachmentKeys.detail(soId ?? ''),
    queryFn: async () => {
      const res = await fetchSalesOrderAttachments(soId!);
      return res.data;
    },
    enabled: !!soId,
    staleTime: 30_000,
  });
}

export function useDownloadOrderDocuments() {
  return useMutation({
    mutationFn: ({ orderId, type }: { orderId: string; type: string }) =>
      downloadOrderDocuments(orderId, type),
  });
}

export function useDownloadLinkDocuments() {
  return useMutation({
    mutationFn: (linkId: string) => downloadLinkDocuments(linkId),
  });
}

export function useSalesOrderAttachmentsRefresh(soId: string) {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: salesOrderAttachmentKeys.detail(soId),
    });
}
